import React, { useState, useEffect, useCallback, useRef } from "react";
import "react-tabs/style/react-tabs.css";
import * as XLSX from "xlsx"; // Import all exports from xlsx library
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
// icons
import { domain, token } from "../../../components/Security";
import axios from "../../../api/apiClient";
import loadingSpinner from "../../../assets/loading.gif";
import { SetAuditTrail } from "../../../components/Reports/AuditTrailReportEmployeeSetup";
import { FEATURES } from "../../../config/features";
import { Button, GeneralMessage, useGeneralMessage } from "../../../common/APICommon";
import { DynamicFilterBar } from "../../components/filters/DynamicFilterBar";
import { useFilterManager } from "../../hooks/useFilterManager";
import { useProcessPayroll } from "../../hooks/useProcessPayroll";
import { LoadingSpinner } from "../../../common/Loading";
import { PayrollHeader } from "../../components/modules/Payroll/components/PayrollHeader";
import { ShowTab } from "../../components/modules/Payroll/components/ShowTab";
import { GenerateMessage } from "../../components/modules/Payroll/components/GenerateMessage";
import { CustomLoader } from "../../components/modules/Payroll/utils/CustomLoader";
import { PostMessage } from "../../components/modules/Payroll/components/PostMessage";
import { UploadForm } from "../../components/modules/Payroll/components/UploadForm";
import { RevertPayrollForm } from "../../components/modules/Payroll/components/RevertPayrollForm";
import { ProcessPayrollForm } from "../../components/modules/Payroll/components/ProcessPayrollForm";
import { PostPayrollForm } from "../../components/modules/Payroll/components/PostPayrollForm";
import { SyncLateAdjustment } from "../../components/modules/Payroll/components/SyncLateAdjustment";
import { useSimulateLoading } from "../../hooks/useSimulateLoading";
import { useOtherAdditionStaging } from "../../hooks/useOtherAdditionStaging";
import { useOtherDeductionStaging } from "../../hooks/useOtherDeductionStaging";
import { useOtherAdjustmentStaging } from "../../hooks/useOtherAdjustmentStaging";
import { usePayrollReasonCode } from "../../hooks/usePayrollReasonCode";

function PayrollPage({ user, userAccess, isHideSideMenu }) {

	const [isUpload, setIsUpload] = useState(false);
	const [isGenerate, setIsGenerate] = useState(false);


	// ==================================================
	// -- New Way --
	// ==================================================

	// Dynamic Message
	const { showMessage, message, isSuccess: isSuccessNew, showGeneralMessage } = useGeneralMessage();

	// Dynamic Filter
	const {
		activeFilterState,
		onFilterChange,
		apiFilterPayload,
		applyFilters,
		resetFilters
	} = useFilterManager(FEATURES.PAYROLL_EMPLOYEE_FILTERS || []);

	// Process Payroll Hook
	const {
		loading: loadingNew,
		payrollData, setPayrollData,
		filterData,
		processPayroll,
		revertPayroll,
		postPayroll,
		fetchDataProcessedPayroll
	} = useProcessPayroll({
		showGeneralMessage,
		apiFilterPayload,
		user
	});
	// ----- destructure the payload
	const {
		PayrollPeriodId: filterPayrollPeriodId,
		PayTypeId: filterPayTypeId,
		ClassificationId: filterClassificationId
	} = apiFilterPayload;

	const {
		loadingOtherAddition,
		otherAdditionData, setOtherAdditionData,
		filterDataAddition, setFilterDataAddition,
		fetchAdditionData
	} = useOtherAdditionStaging({
		setIsUpload,
		isGenerate,
		filterPayTypeId,
		filterPayrollPeriodId,
		filterClassificationId,
	});

	const {
		loadingOtherDeduction,
		otherDeductionData, setOtherDeductionData,
		filterDataDeduction, setFilterDataDeduction,
		fetchDeductionData
	} = useOtherDeductionStaging({
		setIsUpload,
		isGenerate,
		filterPayTypeId,
		filterPayrollPeriodId,
		filterClassificationId,
	});

	const {
		loadingAdjustment, loadingLateAdjustment,
		otherAdjustmentData, setOtherAdjustmentData,
		filterDataAdjustment, setFilterDataAdjustment,
		otherLateAdjustmentData, setOtherLateAdjustmentData,
		filterDataLateAdjustment, setFilterDataLateAdjustment,
		fetchAdjustmentData, fetchLateAdjustmentData
	} = useOtherAdjustmentStaging({
		setIsUpload,
		isGenerate,
		filterPayTypeId,
		filterPayrollPeriodId,
		filterClassificationId,
	});

  const { activeData: activePayrollReasonCodes, fetchActiveReasonCodes } = usePayrollReasonCode();
	// ==================================================
	// -- End New Way --
	// ==================================================



	// ==================================================
	// -- To be modified
	// ==================================================
	const {
		progress,
		loadingPercentage,
		setLoadingPercentage,
		longLoadingRequest,
		setLongLoadingRequest,
		simulateLoading
	} = useSimulateLoading();

	// ==================================================

	const [loadingRequest, setLoadingRequest] = useState(false);
	const [loadingUploadRequest, setLoadingUploadRequest] = useState(false);
	const [showSetting, setShowSetting] = useState(false);
	const settingRef = useRef(null);
	const buttonRef = useRef(null);

	const [payrollDataAdjustment, setPayrollDataAdjustment] = useState([]);

	const [showUploadForm, setShowUploadForm] = useState(false);
	const [settingType, setSettingType] = useState("");
	const [payrollIdForUpload, setPayrollIdForUpload] = useState("");
	const [payTypeIdForUpload, setPayTypeIdForUpload] = useState("");


	const [noDataMessage, setNoDataMessage] = useState(false);
	const [showPostMessage, setShowPostMessage] = useState(false);
	const [successPostMessage, setSuccessPostMessage] = useState(false);
	const [showRevertPayrollForm, setShowRevertPayrollForm] = useState(false);
	const [showProcessPayrollForm, setShowProcessPayrollForm] = useState(false);
	const [showPostPayrollForm, setShowPostPayrollForm] = useState(false);
	const [isRevert, setIsRevert] = useState(false);
	const [isProcess, setIsProcess] = useState(false);
	const [isPost, setIsPost] = useState(false);

	const [type, setType] = useState(0);

	//Request Messages -start
	const [showRequestMessage, setShowRequestMessage] = useState(false);
	const [requestMessage, setRequestMessage] = useState("");
	const [isSuccess, setIsSuccess] = useState("");
	useEffect(() => {
		if (showRequestMessage) {
			const timeoutId = setTimeout(() => {
				setShowRequestMessage(false);
			}, 5000);

			return () => clearTimeout(timeoutId);
		}

	}, [showRequestMessage]);

	const offGenerateLateApprovedAdjustments = true;

	const handleGenerateLateApprovedAdjustments = useCallback(async () => {
		if (!offGenerateLateApprovedAdjustments) {
			let classifiedData = filterClassificationId;

			// Constructing the URL with the correct format
			const apiUrl =
				domain +
				`/api/OtherAdjustmentStaging/generate-late-approval-adjustments/paytype/${filterPayTypeId}/payrollperiod/${filterPayrollPeriodId}/classification/${classifiedData}`;

			try {
				// Making the Axios POST request with the constructed URL
				await axios.post(apiUrl, null, {
					headers: {
						Authorization: `Bearer ${token}`,
						"Content-Type": "application/json",
					},
				});
			} catch (error) {
				console.error("Error fetching data:", error);
			}
		}
	}, [
		filterPayTypeId,
		filterPayrollPeriodId,
		filterClassificationId,
		offGenerateLateApprovedAdjustments,
	]);

	// =============================================================
	// ===================ADJUSTMENTS===============================
	// =============================================================
	// const [loadingOtherAddition, setLoadingOtherAddition] = useState(false);  // recreated with hook
	const [loadingOtherDedujction, setLoadingOtherDedujction] = useState(false);
	// =============================================================
	// ===================ADJUSTMENTS===============================
	// =============================================================
	const handleGenerate = async () => {
		// 1. Validate using the NEW state (Draft filters)
		const payrollPeriodId = activeFilterState.PAYROLLPERIOD?.id;
		const payTypeId = activeFilterState.PAYTYPE?.id;
		const classificationId = activeFilterState.CLASSIFICATION?.id;

		if (!payrollPeriodId || !payTypeId || !classificationId) {
			showGeneralMessage("Please select payroll period, pay type and classification type!", false);
			return;
		}

		// 3. Trigger the New Hook logic
		applyFilters();

		// 4. Set your legacy generate flag
		setIsGenerate(true);
	};
	const handlePost = async (event) => {
		event.preventDefault();

		let classifiedData = filterClassificationId;

		// Constructing the URL with the correct format
		const apiUrl =
			domain +
			`/api/PayrollSummaryStaging/post/${filterPayTypeId}/${filterPayrollPeriodId}/classification/${classifiedData}`;

		try {
			setLoadingRequest(true);
			// Making the Axios POST request with the constructed URL
			await axios.post(apiUrl, null, {
				headers: {
					Authorization: `Bearer ${token}`,
					"Content-Type": "application/json",
				},
			});

			// Rest of your logic for success
			setShowRequestMessage(true);
			setIsSuccess(true);
			// Fetch updated data
			await fetchAdditionData();
			await fetchDeductionData();
			await fetchAdjustmentData();
			await fetchLateAdjustmentData();
			await fetchDataProcessedPayroll();

			closePostMessage();
		} catch (error) {
			// Handling errors
			setShowRequestMessage(true);
			setIsSuccess(false);
			setRequestMessage("Fail to post data!");
		} finally {
			setLoadingRequest(false);
		}
	};

	const handleSetting = () => {
		setShowSetting(!showSetting);
	};
	const closePostMessage = () => {
		setShowPostMessage(false);
	};
	useEffect(() => {
		if (noDataMessage) {
			const timeoutId = setTimeout(() => {
				setNoDataMessage(false);
			}, 5000);

			return () => clearTimeout(timeoutId);
		}
		if (successPostMessage) {
			const timeoutId = setTimeout(() => {
				setSuccessPostMessage(false);
			}, 5000);

			return () => clearTimeout(timeoutId);
		}
	}, [noDataMessage, successPostMessage]);
	useEffect(() => {
		var settingIcon = document.getElementById("setting-icon");

		if (showSetting) {
			//change the down icon to up
			settingIcon.setAttribute("data-testid", "KeyboardArrowUpIcon"); //Up Arrow Test ID
			settingIcon.children[0].setAttribute(
				"d",
				`M7.41 15.41 12 10.83l4.59 4.58L18 14l-6-6-6 6z`
			); // Up Arrow.Path d attribute
		} else {
			//change the up icon to down
			settingIcon.setAttribute("data-testid", "KeyboardArrowDownIcon"); // Down Arrow Test ID
			settingIcon.children[0].setAttribute(
				"d",
				`M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6z`
			); // Down Arrow.Path d attribute
		}

		const handleClickOutside = (event) => {
			if (settingRef.current && !settingRef.current.contains(event.target)) {
				if (buttonRef.current && !buttonRef.current.contains(event.target)) {
					setShowSetting(false);
				}
			}
		};

		document.addEventListener("mousedown", handleClickOutside);

		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [showSetting]);

	const fetchAllEmployees = async () => {
		const apiUrl = domain + "/api/Employee/masterlist";
		try {
			const response = await axios.get(apiUrl, {
				headers: {
					Authorization: `Bearer ${token}`,
					"Content-Type": "application/json", // You can include other headers if needed
				},
			});

			return response.data;
		} catch (error) {
			console.error("Error fetching data:", error);
			return [];
		}
	};

	const generateDownloadTemplate = async () => {
		const workbook = new ExcelJS.Workbook();
		const worksheet = workbook.addWorksheet();

		const header = ["EmployeeId", "EmployeeName", "ReasonCode", "Amount"];
		const headerRow = worksheet.addRow(header);
		worksheet.columns = [
			{ key: "employeePersonalInformationEmployeeId", width: 30 },
			{ key: "employeePersonalInformationFullName", width: 30 },
			{ key: "payrollReasonCodePayrollCode", width: 30 },
			{ key: "amount", width: 30 },
		];
		headerRow.eachCell((cell) => {
			cell.font = { bold: true };
			cell.alignment = { horizontal: "center" };
			cell.border = {
				top: { style: "thin" },
				left: { style: "thin" },
				bottom: { style: "thin" },
				right: { style: "thin" },
			};
			cell.fill = {
				type: "pattern",
				pattern: "solid",
				fgColor: { argb: "92d050" },
			};
		});

		worksheet.addRow([
			"<EMP1234>",
			"<LastName, FirstName>",
			"<eg. 0001>",
			"<500.00>",
		]);

		const buffer = await workbook.xlsx.writeBuffer();
		const blob = new Blob([buffer], {
			type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
		});
		saveAs(blob, "Template.xlsx");
	};
	const generateDownloadAdjustmentTemplate = async () => {
		const workbook = new ExcelJS.Workbook();
		const worksheet = workbook.addWorksheet();

		const header = [
			"EmployeeId",
			"EmployeeName",
			"ReasonCode",
			"Amount",
			"NumberOfHours",
			"AdjustmentDate",
			"ReferenceId",
		];
		const headerRow = worksheet.addRow(header);
		worksheet.columns = [
			{ key: "employeePersonalInformationEmployeeId", width: 30 },
			{ key: "employeePersonalInformationFullName", width: 30 },
			{ key: "payrollReasonCodePayrollCode", width: 30 },
			{ key: "amount", width: 30 },
			{ key: "noIfHours", width: 30 },
			{ key: "adjustmentDate", width: 30 },
			{ key: "referenceId", width: 20 },
		];
		headerRow.eachCell((cell) => {
			cell.font = { bold: true };
			cell.alignment = { horizontal: "center" };
			cell.border = {
				top: { style: "thin" },
				left: { style: "thin" },
				bottom: { style: "thin" },
				right: { style: "thin" },
			};
			cell.fill = {
				type: "pattern",
				pattern: "solid",
				fgColor: { argb: "92d050" },
			};
		});

		worksheet.addRow([
			"<EMP1234>",
			"<LastName, FirstName>",
			"<eg. 0001>",
			"<500.00>",
			"<8.00>",
			"<mm/dd/yyyy>",
			"<REF00001>",
		]);

		const buffer = await workbook.xlsx.writeBuffer();
		const blob = new Blob([buffer], {
			type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
		});
		saveAs(blob, "Template.xlsx");
	};

	const convertToDateTime = (value) => {
		if (
			value === null ||
			value === undefined ||
			value === "" ||
			(typeof value === "string" &&
				value.startsWith("<") &&
				value.endsWith(">"))
		) {
			return null;
		}

		if (!value) {
			return null;
		}

		if (typeof value === "number") {
			// Convert Excel serial number to JavaScript Date
			const excelStartDate = new Date(1899, 11, 31); // Correct base date
			const jsDate = new Date(excelStartDate.getTime() + value * 86400000); // Convert days to milliseconds

			return jsDate.toISOString().split("T")[0];
		}

		if (typeof value === "string") {
			let formattedValue = value.replace(/-/g, "/"); // Ensure compatibility

			const parts = formattedValue.split("/");
			if (parts.length === 3) {
				let [first, second, third] = parts.map((p) => parseInt(p, 10));

				let year, month, day;

				if (third > 31) {
					// Case: YYYY/MM/DD (Ensure proper year detection)
					year = third;
					month = first;
					day = second;
				} else if (first > 12) {
					// Case: DD/MM/YYYY (Auto-detect)
					day = first;
					month = second;
					year = third;
				} else {
					// Case: MM/DD/YYYY (US format)
					month = first;
					day = second;
					year = third;
				}

				return new Date(Date.UTC(year, month - 1, day))
					.toISOString()
					.split("T")[0]; // Return YYYY-MM-DD
			}
		}

		return null;
	};

	const [uploadAdjustments, setUploadAdjustments] = useState([]);
	const uploadFunc = async (file, type, payrollPeriodId, payTypeId) => {
		setLoadingUploadRequest(true);
		const employees = await fetchAllEmployees();

		function sanitizeValue(value) {
			if (
				value === null ||
				value === undefined ||
				value === "" ||
				(typeof value === "string" &&
					value.startsWith("<") &&
					value.endsWith(">"))
			) {
				return "";
			}
			return value;
		}
		function sanitizeValueInt(value) {
			if (
				value === null ||
				value === undefined ||
				value === "" ||
				(typeof value === "string" &&
					value.startsWith("<") &&
					value.endsWith(">"))
			) {
				return 0;
			}
			return value;
		}
		function validateData(data) {
			let newData = [];


			data.forEach((item, index) => {
				const missing = [];

				if (!item.employeePersonalInformationEmployeeId)
					missing.push("Employee Id");
				if (!item.payrollReasonCodePayrollCode) missing.push("Reason Code");
				if (!item.amount) missing.push("Amount");

				if (type === "Other Adjustments") {
					if (!item.noOfHours) missing.push("Number Of Hours");
					if (!item.adjustmentDate) missing.push("Adjustment Date");
					if (!item.referenceId) missing.push("Reference Id");
				}

				// ✅ Construct error message properly
				let errorMessage = "";

				const existingEmployee = employees.find(
					(employee) =>
						employee.employeeId ===
						item.employeePersonalInformationEmployeeId?.toString()
				);
				if (!existingEmployee) {
					errorMessage +=
						errorMessage.length > 0
							? ` Employee Id does not exist.`
							: `Employee Id does not exist. `;
				}

        const existingPayrollReasonCode = activePayrollReasonCodes.find(
          payrollReasonCode =>
            String(payrollReasonCode.payrollCode).trim() ===
            String(item.payrollReasonCodePayrollCode).trim()
        );
        if (!existingPayrollReasonCode) {
					errorMessage +=
						errorMessage.length > 0
							? ` Reason Code does not exist.`
							: `Reason Code does not exist. `;
				}

				if (missing.length > 0) {
					errorMessage += ` Missing fields - ${missing.join(", ")}`;
				}

				newData.push({ ...item, errors: errorMessage });
			});

			newData.sort((a, b) => (a.error ? -1 : 1) - (b.error ? -1 : 1));

			return newData;
		}

		const reader = new FileReader();

		reader.onload = async (e) => {
			const data = new Uint8Array(e.target.result);
			const workbook = XLSX.read(data, { type: "array" });

			const parseWorksheet = (worksheet) => {
				return XLSX.utils.sheet_to_json(worksheet, { defval: "" });
			};

			const informations = parseWorksheet(
				workbook.Sheets[workbook.SheetNames[0]]
			);

			let bulkData = [];

			informations.forEach((info) => {
				let adjustmentDateFormatted = "";

				if (type === "Other Adjustments") {
					adjustmentDateFormatted = convertToDateTime(info.AdjustmentDate);
				}

				bulkData.push({
					employeePersonalInformationEmployeeId: sanitizeValue(
						info.EmployeeId
					).toString(),
					employeePersonalInformationFullName: sanitizeValue(
						info.EmployeeName
					).toString(),
					payrollPeriodId: parseInt(payrollPeriodId),
					payTypeId: parseInt(payTypeId),
					payrollReasonCodePayrollCode: sanitizeValue(info.ReasonCode),
					amount: info.Amount ? parseInt(sanitizeValueInt(info.Amount)) : 0,
					...(type === "Other Adjustments" && {
						noOfHours: info.NumberOfHours
							? parseInt(sanitizeValueInt(info.NumberOfHours))
							: 0,
					}),
					...(type === "Other Adjustments" && {
						adjustmentDate: adjustmentDateFormatted,
					}),
					...(type === "Other Adjustments" && {
						referenceId: info.ReferenceId
							? sanitizeValueInt(info.ReferenceId)
							: 0,
					}),
					...(type === "Other Adjustments" && { transactionType: "Leave" }),
				});
			});

			const validatedData = validateData(bulkData);
			const sortedData = validatedData.sort((a, b) => {
				const hasErrorA = a.errors && a.errors.length > 0;
				const hasErrorB = b.errors && b.errors.length > 0;

				return hasErrorB - hasErrorA; // Move items with errors to the top
			});
			setUploadAdjustments(sortedData);
		};

		setLoadingUploadRequest(false);
		reader.readAsArrayBuffer(file);
	};
	const handleFileUpload = async (files, type, payrollPeriodId, payTypeId) => {
		if (!files || files.length === 0) {
			console.error("No files selected");
			return;
		}

		const file = files[0];
		uploadFunc(file, type, payrollPeriodId, payTypeId);
	};
	const handleFinalFileUpload = async (bulkData, type) => {
		setLoadingRequest(true);

		var apiUrl = "";
		if (type === "Other Additions") {
			apiUrl = domain + "/api/OtherAdditionStaging/bulk";
		} else if (type === "Other Deductions") {
			apiUrl = domain + "/api/OtherDeductionStaging/bulk";
		} else if (type === "Other Adjustments") {
			apiUrl = domain + "/api/OtherAdjustmentStaging/bulk";
		}

		try {
			axios.post(apiUrl, bulkData, {
				headers: {
					Authorization: `Bearer ${token}`,
					"Content-Type": "application/json",
				},
			});

			let field = "";

			if (type === "Other Additions") {
				field = "Upload Other Additions";
			} else if (type === "Other Deductions") {
				field = "Upload Other Deductions";
			} else if (type === "Other Adjustments") {
				field = "Upload Other Adjustments";
			}

			await SetAuditTrail({
				setupArea: "Payroll",
				actionTaken: "insert",
				field: field,
				newValue: "[bulk data]",
				oldValue: "-",
				dateSaved: new Date(),
				savedById: user.id,
			});

			setTimeout(async () => {
				await fetchAdditionData();
				await fetchDeductionData();
				await fetchAdjustmentData();
				await fetchLateAdjustmentData();
				await fetchDataProcessedPayroll();
			}, 1000);

			setShowRequestMessage(true);
			setIsSuccess(true);
			setIsUpload(true);
		} catch (error) {
			console.error("Error parsing Excel file:", error);
			setShowRequestMessage(true);
			setIsSuccess(false);

			if (error.response && error.response.data && error.response.data.errors) {
				const errorMessage = error.response.data.errors["$"][0]; // Accessing the error message
				setRequestMessage(errorMessage);
			} else if (
				error.response &&
				error.response.data &&
				error.response.data.message
			) {
				const errorMessage = error.response.data.message; // Fallback to general message
				setRequestMessage(errorMessage);
			} else {
				setRequestMessage("An unknown error occurred."); // Default message
			}
		} finally {
			setLoadingRequest(false);
		}
	};

	const openUploadFormHandleClick = () => {
		setShowUploadForm(true);
	};
	const closeUploadFormHandleClick = () => {
		setShowUploadForm(false);
	};
	const openRevertPayrollForm = () => {
		setShowRevertPayrollForm(true);
	};
	const closeRevertPayrollForm = () => {
		setShowRevertPayrollForm(false);
	};
	const openProcessPayrollForm = () => {
		setShowProcessPayrollForm(true);
	};
	const closeProcessPayrollForm = () => {
		setShowProcessPayrollForm(false);
	};
	const openPostPayrollForm = () => {
		setShowPostPayrollForm(true);
	};
	const closePostPayrollForm = () => {
		setShowPostPayrollForm(false);
	};

	const [showLateAdjustmentForm, setShowLateAdjustmentForm] = useState(false);
	const openLateAdjustmentForm = () => {
		setShowLateAdjustmentForm(true);
	};
	const closeLateAdjustmentForm = () => {
		setShowLateAdjustmentForm(false);
	};


  useEffect(() => { fetchActiveReasonCodes(); }, [fetchActiveReasonCodes])
	return (
		<div>
			<div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
				<div className="LeftSpace"></div>
				<div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
					<div className="PayrollInfo shadow-xl">
						<div className="sub-title row" style={{ padding: "5px 20px" }}>
							<span style={{ padding: "0 5px 0 0", color: "#b0b0b0" }}>
								{"Payroll >"}{" "}
							</span>
							<span style={{ borderBottom: "1px solid black" }}>
								{"Process Payroll"}
							</span>
						</div>
						<PayrollHeader
							buttonRef={buttonRef}
							settingRef={settingRef}
							showSetting={showSetting}
							handleSetting={handleSetting}
							generateDownloadTemplate={generateDownloadTemplate}
							generateDownloadAdjustmentTemplate={generateDownloadAdjustmentTemplate}
							openUploadFormHandleClick={openUploadFormHandleClick}
							openRevertPayrollForm={openRevertPayrollForm}
							openProcessPayrollForm={openProcessPayrollForm}
							openPostPayrollForm={openPostPayrollForm}
							setSettingType={setSettingType}
              showGeneralMessage={showGeneralMessage}
						/>
						<div className="payroll-body">
							<div className="mb-2 rounded-lg border border-gray-200 bg-white p-4 shadow-sm" style={{ border: "1px solid #d7d7d7" }}>
								<span className="mb-4 block text-lg font-semibold text-gray-600">Filters</span>
								<DynamicFilterBar
									requestedFilters={FEATURES.PAYROLL_EMPLOYEE_FILTERS || []}
									activeFilterState={activeFilterState}
									onFilterChange={onFilterChange}
									showButtons={false}
								/>
								<div className="mt-5 flex gap-2 border-t pt-4">
									<Button name="GENERATE" className="cursor-pointer rounded border-none bg-blue-600 px-5 py-2 font-bold text-white" onClick={handleGenerate} />
									<Button name="CLEAR" className="cursor-pointer rounded border-none bg-gray-400 px-5 py-2 text-white" onClick={resetFilters} />
								</div>
							</div>

							<ShowTab
								type={type}
								setType={setType}
								filterPayrollPeriodId={filterPayrollPeriodId}
								filterPayTypeId={filterPayTypeId}
								filterClassificationId={filterClassificationId}
								userAccess={userAccess}
								payrollData={payrollData}
								setPayrollData={setPayrollData}
								payrollDataAdjustment={payrollDataAdjustment}
								setPayrollDataAdjustment={setPayrollDataAdjustment}
								otherAdditionData={otherAdditionData}
								otherDeductionData={otherDeductionData}
								otherAdjustmentData={otherAdjustmentData}
								otherLateAdjustmentData={otherLateAdjustmentData}
								setOtherAdditionData={setOtherAdditionData}
								setOtherDeductionData={setOtherDeductionData}
								setOtherAdjustmentData={setOtherAdjustmentData}
								setOtherLateAdjustmentData={setOtherLateAdjustmentData}
								showPostMessage={showPostMessage}
								isGenerate={isGenerate}
								isRevert={isRevert}
								isProcess={isProcess}
								isPost={isPost}
								isUpload={isUpload}
								setIsUpload={setIsUpload}
								loading={loadingNew}
								fetchData={fetchDataProcessedPayroll}
								filterData={filterData}
								loadingOtherAddition={loadingOtherAddition}
								loadingOtherDedujction={loadingOtherDedujction}
								loadingAdjustment={loadingAdjustment}
								loadingLateAdjustment={loadingLateAdjustment}
								filterDataAddition={filterDataAddition}
								filterDataDeduction={filterDataDeduction}
								filterDataAdjustment={filterDataAdjustment}
								filterDataLateAdjustment={filterDataLateAdjustment}
								fetchAdditionData={fetchAdditionData}
								fetchDeductionData={fetchDeductionData}
								fetchAdjustmentData={fetchAdjustmentData}
								fetchLateAdjustmentData={fetchLateAdjustmentData}
								fetchDataProcessedPayroll={fetchDataProcessedPayroll}
								handleGenerateLateApprovedAdjustments={
									handleGenerateLateApprovedAdjustments
								}
								openLateAdjustmentForm={openLateAdjustmentForm}
								user={user}
							/>
						</div>
					</div>
				</div>
			</div>
			<UploadForm
				isOpen={showUploadForm}
				onClose={closeUploadFormHandleClick}
				payrollPeriodId={payrollIdForUpload}
				payTypeId={payTypeIdForUpload}
				setPayrollPeriodId={setPayrollIdForUpload}
				setPayTypeId={setPayTypeIdForUpload}
				type={settingType}
				data_temp={uploadAdjustments}
				setData_temp={setUploadAdjustments}
				handleFileUpload={handleFileUpload}
				handleFinalFileUpload={handleFinalFileUpload}
			></UploadForm>
			<PostMessage
				isOpen={showPostMessage}
				onClose={closePostMessage}
				handlePost={handlePost}
			></PostMessage>
			<RevertPayrollForm
				isOpen={showRevertPayrollForm}
				onClose={closeRevertPayrollForm}
				progress={progress}
				simulateLoading={simulateLoading}
				setLoadingPercentage={setLoadingPercentage}
				setLoadingRequest={setLongLoadingRequest}
				fetchOtherAddition={fetchAdditionData}
				fetchOtherDeduction={fetchDeductionData}
				fetchOtherAdjustment={fetchAdjustmentData}
				fetchLateAdjustmentData={fetchLateAdjustmentData}
				fetchProcess={fetchDataProcessedPayroll}
				showGeneralMessage={showGeneralMessage}
				revertPayroll={revertPayroll}
				setIsRevert={setIsRevert}
			></RevertPayrollForm>
			<ProcessPayrollForm
				isOpen={showProcessPayrollForm}
				onClose={closeProcessPayrollForm}
				progress={progress}
				simulateLoading={simulateLoading}
				setLoadingPercentage={setLoadingPercentage}
				setLoadingRequest={setLongLoadingRequest}
				fetchOtherAddition={fetchAdditionData}
				fetchOtherDeduction={fetchDeductionData}
				fetchOtherAdjustment={fetchAdjustmentData}
				fetchLateAdjustmentData={fetchLateAdjustmentData}
				fetchProcess={fetchDataProcessedPayroll}
				showGeneralMessage={showGeneralMessage}
				processPayroll={processPayroll}
				setIsProcess={setIsProcess}
			></ProcessPayrollForm>
			<PostPayrollForm
				isOpen={showPostPayrollForm}
				onClose={closePostPayrollForm}
				progress={progress}
				simulateLoading={simulateLoading}
				setLoadingPercentage={setLoadingPercentage}
				setLoadingRequest={setLongLoadingRequest}
				fetchOtherAddition={fetchAdditionData}
				fetchOtherDeduction={fetchDeductionData}
				fetchOtherAdjustment={fetchAdjustmentData}
				fetchLateAdjustmentData={fetchLateAdjustmentData}
				fetchProcess={fetchDataProcessedPayroll}
				showGeneralMessage={showGeneralMessage}
				postPayroll={postPayroll}
				setIsPost={setIsPost}
			></PostPayrollForm>
			<SyncLateAdjustment
				isOpen={showLateAdjustmentForm}
				onClose={closeLateAdjustmentForm}
				fetchOtherAddition={fetchAdditionData}
				fetchOtherDeduction={fetchDeductionData}
				fetchOtherAdjustment={fetchAdjustmentData}
				fetchLateAdjustmentData={fetchLateAdjustmentData}
				fetchProcess={fetchDataProcessedPayroll}
				mainPayrollPeriod={filterPayrollPeriodId}
				setIsPost={setIsPost}
				isGenerate={isGenerate}
				user={user}
			></SyncLateAdjustment>
			<GenerateMessage
				form={noDataMessage}
				message={"No data to post!"}
				isSuccess={false}
			></GenerateMessage>
			<GenerateMessage
				form={successPostMessage}
				message={"Data posted!"}
				isSuccess={true}
			></GenerateMessage>
			<GenerateMessage
				form={showRequestMessage}
				message={isSuccess ? "Request Success!" : requestMessage}
				isSuccess={isSuccess}
			></GenerateMessage>
			{loadingRequest ? (
				<div
					style={{
						position: "fixed",
						top: "50%",
						left: "50%",
						transform: "translate(-50%, -50%)",
						zIndex: "3005",
					}}
				>
					<img src={loadingSpinner} alt="Loading..." />
				</div>
			) : (
				<></>
			)}

			<LoadingSpinner loading={loadingNew || loadingUploadRequest} />
			<GeneralMessage form={showMessage} message={message} isSuccess={isSuccessNew} />

			{longLoadingRequest ? (
				<CustomLoader loadingPercentage={loadingPercentage} />
			) : (
				<></>
			)}
		</div>
	);
}

export default PayrollPage;